import api from "../apiConfig";
import paramsFactory from "../../utils/paramsFactory";

export default {
  fetchCrmMetrics(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/commerce/crm-metrics?${p}`);
  },
  fetchEmployeeActivity(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/kpi/commerce/employee-activity?${p}`);
  },
};
